/**
 * Contact Header Component
 * 
 * Displays the introductory section of the contact page with:
 * - A subtitle label
 * - Main page title
 * - Descriptive text explaining the purpose of the contact page
 * 
 * This component provides context to users about what they can do on this page
 * (request quotes, ask questions, etc.)
 * 
 * @component
 * @returns {JSX.Element} Contact page header section with title and description
 */

import React from 'react';
import './contact-header-style.css';

const ContactHeader = () => {
  return (
    <div className="contact-header">
      {/* Subtitle/label above main title */}
      <p className="contact-header__subtitle">HABLEMOS</p>
      {/* Main page heading */}
      <h1 className="contact-header__title">Contáctanos</h1>
      {/* Description explaining what users can do on this page */}
      <p className="contact-header__description">
        Estamos listos para atender tus necesidades de bordado. Escríbenos para solicitar una cotización o resolver tus dudas.
      </p>
    </div>
  );
};

export default ContactHeader;
